// import React, { useEffect, useState } from "react";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import { useAuth } from "../../Utility/AuthProvider";
// import { IoIosAdd } from "react-icons/io";
// import { CiSearch } from "react-icons/ci";
// import ToggleBtn from "../../components/Buttons/ToggleBtn";
// import FilterBtn from "../../components/Buttons/FilterBtn";
// import TenantStatusBtn from "../../components/Buttons/TenantStatusBtn";
// import CircularInitial from "../UpcomingRent/CircularInitial";
// import { CiCircleInfo } from "react-icons/ci";
// import { CiWallet } from "react-icons/ci";
// import { useNavigate } from "react-router-dom";

// function TenantsList() {
//   const { jwt } = useAuth();
//   const [tenantData, setTenantData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [filteredData, setFilteredData] = useState([]);
//   const [selectedFilters, setSelectedFilters] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await APICall(
//           "GET",
//           paths.tenant.fetchAll,
//           undefined,
//           undefined,
//           jwt
//         );

//         console.log("Response of tenant fetchAll call:", response);

//         if (response && response.response && Array.isArray(response.response)) {
//           // Validate response
//           setTenantData(response.response);
//           console.log("Tenant Data:", response.response);
//         } else if (response && response.message) {
//           // Handle API error
//           setError(response.message); // Set the error message
//           console.error("API Error:", response.message);
//         } else {
//           // Handle other errors or no data
//           setError("Error fetching tenants or no tenants found.");
//           console.error(
//             "Error fetching tenants or no tenants found:",
//             response
//           );
//         }
//       } catch (error) {
//         console.error("Error fetching data (catch block):", error);
//         setError("An error occurred while fetching tenants."); // Set a generic error message
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [jwt]);

//   useEffect(() => {
//     if (tenantData) {
//       // Only apply filters if tenantData is not null
//       const applyFilters = () => {
//         let data = tenantData; // Now safe to use tenantData

//         // ... (rest of your filtering logic, same as before)
//         // Apply search filter
//         if (searchQuery) {
//           data = data.filter(
//             (tenant) =>
//               tenant.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//               tenant.mobile.includes(searchQuery) ||
//               tenant.unit_name.toLowerCase().includes(searchQuery.toLowerCase())
//           );
//         }

//         // Apply selected filters
//         if (selectedFilters.length > 0) {
//           data = data.filter((tenant) => {
//             // Check if the tenant's status matches any selected filter
//             if (selectedFilters.includes(tenant.status)) {
//               return true;
//             }

//             // Check "Due" filter
//             if (selectedFilters.includes("Due") && tenant.due_date) {
//               const dueInDays = parseInt(tenant.due_date, 10);
//               if (dueInDays >= 0 && dueInDays <= 14) {
//                 return true;
//               }
//             }

//             // Check "Paid" filter
//             if (selectedFilters.includes("Paid") && tenant.due_date) {
//               const dueInDays = parseInt(tenant.due_date, 10);
//               if (dueInDays >= 23 && dueInDays <= 31) {
//                 return true;
//               }
//             }

//             // Default to exclude if no match
//             return false;
//           });
//         }

//         setFilteredData(data);
//       };

//       applyFilters();
//     } else {
//       setFilteredData([]); // Set to empty array if tenantData is null
//     }
//   }, [tenantData, selectedFilters, searchQuery]);

//   // useEffect(() => {
//   //   const applyFilters = () => {
//   //     let data = tenantData;

//   //     // Apply search filter
//   //     if (searchQuery) {
//   //       data = data.filter(
//   //         (tenant) =>
//   //           tenant.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//   //           tenant.mobile.includes(searchQuery) ||
//   //           tenant.unit_name.toLowerCase().includes(searchQuery.toLowerCase())
//   //       );
//   //     }

//   //     // Apply selected filters
//   //     if (selectedFilters.length > 0) {
//   //       data = data.filter((tenant) => {
//   //         // Check if the tenant's status matches any selected filter
//   //         if (selectedFilters.includes(tenant.status)) {
//   //           return true;
//   //         }

//   //         // Check "Due" filter
//   //         if (selectedFilters.includes("Due") && tenant.due_date) {
//   //           const dueInDays = parseInt(tenant.due_date, 10);
//   //           if (dueInDays >= 0 && dueInDays <= 14) {
//   //             return true;
//   //           }
//   //         }

//   //         // Check "Paid" filter
//   //         if (selectedFilters.includes("Paid") && tenant.due_date) {
//   //           const dueInDays = parseInt(tenant.due_date, 10);
//   //           if (dueInDays >= 23 && dueInDays <= 31) {
//   //             return true;
//   //           }
//   //         }

//   //         // Default to exclude if no match
//   //         return false;
//   //       });
//   //     }

//   //     setFilteredData(data);
//   //   };

//   //   applyFilters();
//   // }, [tenantData, selectedFilters, searchQuery]);

//   const toggleFilter = (filter) => {
//     setSelectedFilters((prevSelected) =>
//       prevSelected.includes(filter)
//         ? prevSelected.filter((item) => item !== filter)
//         : [...prevSelected, filter]
//     );
//   };

//   const getStatusProps = (due_date) => {
//     if (due_date === "Overdue") {
//       return {
//         label: "Overdue",
//         className: "text-red border border-red-500",
//         icon: <CiCircleInfo size={15} color="red" />,
//       };
//     }
//     const dueInDays = parseInt(due_date, 10);
//     if (!isNaN(dueInDays)) {
//       if (dueInDays >= 0 && dueInDays <= 22) {
//         return {
//           label: `Due in ${dueInDays} days`,
//           className: "text-orange-500 border border-orange-500",
//           icon: <CiCircleInfo size={15} color="orange" />,
//         };
//       } else if (dueInDays >= 23 && dueInDays <= 31) {
//         return {
//           label: "Paid",
//           className: "text-blue-700 border border-blue-700",
//           icon: <CiWallet size={15} color="blue" />,
//         };
//       }
//     }
//     return { label: "Unknown", className: "bg-gray-500 text-white" };
//   };

//   const handleClearFilters = () => {
//     setSelectedFilters([]);
//   };

//   function navigateAddTenant() {
//     navigate("/AddNewTenant");
//   }

//   const filters = ["Active", "Paid", "Due", "Overdue", "Inactive"];

//   return (
//     <div className="p-10 border-2 rounded-2xl">
//       <div className="flex items-center justify-between">
//         <p className="font-black">My Tenant</p>
//         <button
//           onClick={navigateAddTenant}
//           className="flex items-center bg-blue-700 text-white text-xs p-3 rounded-full"
//         >
//           <IoIosAdd size={15} />
//           Add New
//         </button>
//       </div>
//       <div className="flex items-center border-gray border mt-4 p-2 rounded-full gap-2">
//         <CiSearch size={20} />
//         <input
//           type="text"
//           placeholder="Search"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           className="flex-grow outline-none bg-transparent"
//         />
//       </div>

//       <div className="tenant-filter-container mt-5">
//         <div className="flex flex-wrap gap-2">
//           <FilterBtn
//             selectedFiltersCount={selectedFilters.length}
//             onClick={handleClearFilters}
//           />

//           {filters.map((filter) => (
//             <ToggleBtn
//               key={filter}
//               label={filter}
//               isSelected={selectedFilters.includes(filter)}
//               onClick={() => toggleFilter(filter)}
//             />
//           ))}
//         </div>
//       </div>

//       <div className="mt-5 border rounded-2xl">
//         <table className="w-full">
//           <thead className="text-sm">
//             <tr>
//               <th className="px-4 py-2 text-left">Name</th>
//               <th className="px-4 py-2 text-left">Mobile Number</th>
//               <th className="px-3 py-2 text-left">Unit Address</th>
//               <th className="px-4 py-2 text-left">Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredData.length > 0 ? (
//               filteredData.map((tenant, index) => (
//                 <tr className="text-xs" key={index}>
//                   <td className="px-4 py-2 border-b flex items-center gap-4">
//                     <div className=" text-white rounded-full h-8 w-8 flex items-center justify-center text-xs">
//                       <CircularInitial
//                         firstName={tenant.first_name}
//                         lastName={tenant.last_name}
//                       />
//                     </div>
//                     <p className="text-black">{tenant.name}</p>
//                   </td>
//                   <td className="px-4 py-2 border-b">{tenant.mobile}</td>
//                   <td className="px-4 py-2 border-b">{tenant.unit_name}</td>
//                   <td className="px-4 py-2 border-b">
//                     <TenantStatusBtn {...getStatusProps(tenant.due_date)} />
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="4" className="px-4 py-2 text-gray-600 text-center">
//                   No tenants found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default TenantsList;

// import React, { useEffect, useState } from "react";
// // Remove APICall and paths as they are no longer directly used for fetching here
// // import APICall from "../../Utility/APICall";
// // import { paths } from "../../Utility/Constants";
// import { useAuth } from "../../Utility/AuthProvider"; // Keep useAuth for jwt if needed elsewhere
// import { IoIosAdd } from "react-icons/io";
// import { CiSearch } from "react-icons/ci";
// import ToggleBtn from "../../components/Buttons/ToggleBtn";
// import FilterBtn from "../../components/Buttons/FilterBtn";
// import TenantStatusBtn from "../../components/Buttons/TenantStatusBtn";
// import CircularInitial from "../UpcomingRent/CircularInitial";
// import { CiCircleInfo } from "react-icons/ci";
// import { CiWallet } from "react-icons/ci";
// import { useNavigate } from "react-router-dom";
// // import { useTenants } from "../Tenants/TenantContext";
// import { useTenantContext } from "../Tenants/TenantContext";
// import Lottie from "lottie-react";
// import loaderAnimation from "../../assets/animations/loader.json";
// import {
//   useReportsData,
//   useUpdateReportsData,
//   Loading,
//   formatAmount,
//   debugAmountValues,
//   debugSelectedTenant,
// } from "../../Contexts/ReportsContext";

// function TenantsList() {
//   const { jwt } = useAuth(); // Still get JWT if needed for other components/actions
//   // Remove local tenantData state and the loading/error states that were tied to it
//   // const [tenantData, setTenantData] = useState([]);
//   // const [loading, setLoading] = useState(true);
//   // const [error, setError] = useState(null);

//   // Use the tenant data and loading/error states from the context
//   const {
//     allTenants, // This will be your primary source of tenant data now
//     tenantData,
//     isLoadingTenants, // Use this for loading state
//     tenantError, // Use this for error state
//     fetchAllTenants, // Keep this if you need a way to force a refresh manually
//     fetchTenantById, // Keep this if you need to fetch a single tenant by ID
//   } = useTenantContext();

//   const { rentData } = useReportsData();

//   const [filteredData, setFilteredData] = useState([]);
//   const [selectedFilters, setSelectedFilters] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const navigate = useNavigate();

//   console.log("TenantData from context:", tenantData);
//   console.log("RentData from context:", rentData);

//   // --- Keep this useEffect, but change its dependency and data source ---
//   useEffect(() => {
//     // This useEffect will now react to changes in 'allTenants' from the context
//     // and apply filters to it.
//     if (tenantData) {
//       // Ensure allTenants is not null/undefined
//       const applyFilters = () => {
//         let data = [...tenantData]; // Start with a copy of allTenants from context

//         // Apply search filter
//         if (searchQuery) {
//           data = data.filter(
//             (tenant) =>
//               (
//                 tenant.first_name?.toLowerCase() +
//                 " " +
//                 tenant.last_name?.toLowerCase()
//               ).includes(searchQuery.toLowerCase()) || // Assuming name is first_name + last_name
//               tenant.mobile?.includes(searchQuery) ||
//               tenant.unit_name
//                 ?.toLowerCase()
//                 .includes(searchQuery.toLowerCase()) // Use optional chaining for safety
//           );
//         }

//         // Apply selected filters
//         if (selectedFilters.length > 0) {
//           data = data.filter((tenant) => {
//             // Check if the tenant's status matches any selected filter
//             if (selectedFilters.includes(tenant.status)) {
//               return true;
//             }

//             // Check "Due" filter
//             // Ensure tenant.due_date is available before parsing
//             if (
//               selectedFilters.includes("Due") &&
//               tenant.due_date !== undefined &&
//               tenant.due_date !== null &&
//               tenant.due_date !== "Overdue"
//             ) {
//               const dueInDays = parseInt(tenant.due_date, 10);
//               if (!isNaN(dueInDays) && dueInDays >= 0 && dueInDays <= 22) {
//                 // Adjusted range as per getStatusProps logic
//                 return true;
//               }
//             }

//             // Check "Paid" filter
//             // Ensure tenant.due_date is available before parsing
//             if (
//               selectedFilters.includes("Paid") &&
//               tenant.due_date !== undefined &&
//               tenant.due_date !== null &&
//               tenant.due_date !== "Overdue"
//             ) {
//               const dueInDays = parseInt(tenant.due_date, 10);
//               if (!isNaN(dueInDays) && dueInDays >= 23 && dueInDays <= 31) {
//                 // Adjusted range as per getStatusProps logic
//                 return true;
//               }
//             }
//             // Check "Overdue" filter based on the string value
//             if (
//               selectedFilters.includes("Overdue") &&
//               tenant.due_date === "Overdue"
//             ) {
//               return true;
//             }

//             // Default to exclude if no match
//             return false;
//           });
//         }

//         setFilteredData(data);
//       };

//       applyFilters();
//     } else {
//       setFilteredData([]); // Set to empty array if allTenants is null/undefined
//     }
//   }, [tenantData, selectedFilters, searchQuery]); // Now depends on allTenants from context

//   const toggleFilter = (filter) => {
//     setSelectedFilters((prevSelected) =>
//       prevSelected.includes(filter)
//         ? prevSelected.filter((item) => item !== filter)
//         : [...prevSelected, filter]
//     );
//   };

//   const getStatusProps = (due_date) => {
//     if (due_date === "Overdue") {
//       return {
//         label: "Overdue",
//         className: "text-red-500 border border-red-500", // Use Tailwind classes directly
//         icon: <CiCircleInfo size={15} color="red" />,
//       };
//     }
//     const dueInDays = parseInt(due_date, 10);
//     if (!isNaN(dueInDays)) {
//       if (dueInDays >= 0 && dueInDays <= 22) {
//         // Due in 0-22 days
//         return {
//           label: `Due in ${dueInDays} days`,
//           className: "text-orange-500 border border-orange-500",
//           icon: <CiCircleInfo size={15} color="orange" />,
//         };
//       } else if (dueInDays >= 23 && dueInDays <= 31) {
//         // Paid (23-31 days until next due date typically)
//         return {
//           label: "Paid",
//           className: "text-blue-700 border border-blue-700",
//           icon: <CiWallet size={15} color="blue" />,
//         };
//       }
//     }
//     return { label: "Unknown", className: "bg-gray-500 text-white" };
//   };

//   const handleClearFilters = () => {
//     setSelectedFilters([]);
//   };

//   function navigateAddTenant() {
//     navigate("/AddNewTenant");
//   }

//   const filters = ["Active", "Paid", "Due", "Overdue", "Inactive"];

//   // Use isLoadingTenants and tenantError from context for UI feedback
//   if (isLoadingTenants) {
//     // return (
//     //   <div className="flex justify-center items-center h-48">
//     //     <p>Loading tenants...</p>
//     //   </div>
//     // );
//     return (
//       <div className="flex justify-center items-center h-[calc(100vh-150px)]">
//         {" "}
//         {/* Adjust height as needed */}
//         <Lottie
//           animationData={loaderAnimation}
//           loop={true}
//           style={{ width: 150, height: 150 }}
//         />
//       </div>
//     );
//   }

//   if (tenantError) {
//     return (
//       <div className="flex justify-center items-center h-48 text-red-600">
//         <p>Error: {tenantError}</p>
//         {/* Optional: Add a retry button */}
//         <button
//           onClick={() => fetchAllTenants(true)}
//           className="ml-4 px-3 py-1 bg-blue-500 text-white rounded"
//         >
//           Retry
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="p-10 border-2 rounded-2xl">
//       <div className="flex items-center justify-between">
//         <p className="font-black">My Tenant</p>
//         <button
//           onClick={navigateAddTenant}
//           className="flex items-center bg-blue-700 text-white text-xs p-3 rounded-full"
//         >
//           <IoIosAdd size={15} />
//           Add New
//         </button>
//       </div>
//       <div className="flex items-center border-gray border mt-4 p-2 rounded-full gap-2">
//         <CiSearch size={20} />
//         <input
//           type="text"
//           placeholder="Search"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           className="flex-grow outline-none bg-transparent"
//         />
//       </div>

//       <div className="tenant-filter-container mt-5">
//         <div className="flex flex-wrap gap-2">
//           <FilterBtn
//             selectedFiltersCount={selectedFilters.length}
//             onClick={handleClearFilters}
//           />

//           {filters.map((filter) => (
//             <ToggleBtn
//               key={filter}
//               label={filter}
//               isSelected={selectedFilters.includes(filter)}
//               onClick={() => toggleFilter(filter)}
//             />
//           ))}
//         </div>
//       </div>

//       <div className="mt-5 border rounded-2xl">
//         <table className="w-full">
//           <thead className="text-sm">
//             <tr>
//               <th className="px-4 py-2 text-left">Name</th>
//               <th className="px-4 py-2 text-left">Mobile Number</th>
//               <th className="px-3 py-2 text-left">Unit Address</th>
//               <th className="px-4 py-2 text-left">Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredData.length > 0 ? (
//               filteredData.map((tenant, index) => (
//                 <tr className="text-xs" key={tenant.entity_id || index}>
//                   {/* Use a stable key like entity_id */}
//                   <td className="px-4 py-2 border-b flex items-center gap-4">
//                     <div className=" text-white rounded-full h-8 w-8 flex items-center justify-center text-xs">
//                       <CircularInitial
//                         firstName={tenant.first_name}
//                         lastName={tenant.last_name}
//                       />
//                     </div>
//                     <p className="text-black">
//                       {tenant.first_name} {tenant.last_name}
//                     </p>{" "}
//                     {/* Use first_name and last_name */}
//                   </td>
//                   <td className="px-4 py-2 border-b">{tenant.mobile}</td>
//                   <td className="px-4 py-2 border-b">{tenant.unit_name}</td>
//                   <td className="px-4 py-2 border-b">
//                     <TenantStatusBtn {...getStatusProps(tenant.due_date)} />
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="4" className="px-4 py-2 text-gray-600 text-center">
//                   {/* Display appropriate message based on loading/error/no data */}
//                   {!isLoadingTenants && !tenantError && allTenants.length === 0
//                     ? "No tenants found in the system."
//                     : "No tenants match your current filters."}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default TenantsList;

// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import { useAuth } from "../../Utility/AuthProvider";
// import { useNavigate } from "react-router-dom";
// import Lottie from "lottie-react";
// import { IoIosAdd } from "react-icons/io";
// import { CiSearch, CiCircleInfo, CiWallet } from "react-icons/ci";
// import { FaCheckCircle } from "react-icons/fa"; // For "No Dues" icon

// // --- Context Imports ---
// import { useTenantContext } from "../Tenants/TenantContext";
// import { useReportsData } from "../../Contexts/ReportsContext";

// import Filters from "../Common/Filter";

// // --- Component & Utility Imports ---
// import ToggleBtn from "../../components/Buttons/ToggleBtn";
// import FilterBtn from "../../components/Buttons/FilterBtn";
// import TenantStatusBtn from "../../components/Buttons/TenantStatusBtn";
// import CircularInitial from "../UpcomingRent/CircularInitial";
// // import WhatsAppComponent from "../../components/Buttons/WhatsAppComponent"; // 🔥 IMPORT WhatsAppComponent
// import WhatsAppComponent from "../Reports/components/WhatsappComponent";
// import { getTenantProfileImageURL } from "../../Utility/tenantFileUtils"; // 🔥 IMPORT the image utility
// import loaderAnimation from "../../assets/animations/loader.json";

// function TenantsList() {
//   const { jwt } = useAuth();
//   const navigate = useNavigate();

//   // --- Consume Contexts ---
//   const { tenantData, isLoadingTenants, tenantError, fetchAllTenants } =
//     useTenantContext();
//   const { rentData } = useReportsData();

//   // --- Local State ---
//   const [filteredData, setFilteredData] = useState([]);
//   const [selectedFilters, setSelectedFilters] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");

//   const [nestedFilters, setNestedFilters] = useState({
//     buildingIds: [],
//     unitIds: [],
//     tenantIds: [],
//   });

//   // 🔥 CORE LOGIC: Combine tenant data with their pending payments using useMemo for performance.
//   const tenantsWithPendingPayments = useMemo(() => {
//     if (!tenantData || !rentData?.all) {
//       return []; // Return empty if essential data isn't ready
//     }

//     // 1. Create a flat list of all pending payment records from rentData
//     const allPendingItems = rentData.all.flatMap(
//       (section) => section.data.filter((item) => item.due_in) // `due_in` signifies a pending/overdue payment
//     );

//     // 2. Create a Map for efficient lookup (TenantID -> [PendingItem1, PendingItem2, ...])
//     const pendingPaymentsMap = new Map();
//     allPendingItems.forEach((item) => {
//       if (!pendingPaymentsMap.has(item.tenant_id)) {
//         pendingPaymentsMap.set(item.tenant_id, []);
//       }
//       pendingPaymentsMap.get(item.tenant_id).push(item);
//     });

//     // 3. Map over the main tenant list and attach their pending payments
//     return tenantData.map((tenant) => {
//       const pendingItems = pendingPaymentsMap.get(tenant.entity_id) || [];
//       return {
//         ...tenant,
//         pendingPayments: pendingItems, // Add the new property
//       };
//     });
//   }, [tenantData, rentData]); // This calculation only re-runs if tenantData or rentData changes

//   // --- Filtering Logic (now uses the enhanced tenant data) ---
//   useEffect(() => {
//     // This useEffect will now react to changes in the combined data
//     if (tenantsWithPendingPayments) {
//       let data = [...tenantsWithPendingPayments]; // Use the memoized data

//       if (searchQuery) {
//         data = data.filter(
//           (tenant) =>
//             `${tenant.first_name} ${tenant.last_name}`
//               .toLowerCase()
//               .includes(searchQuery.toLowerCase()) ||
//             tenant.mobile?.includes(searchQuery) ||
//             tenant.unit_name?.toLowerCase().includes(searchQuery.toLowerCase())
//         );
//       }
//       if (nestedFilters.buildingIds.length > 0) {
//         data = data.filter((tenant) =>
//           nestedFilters.buildingIds.includes(tenant.building_id)
//         );
//       }
//       if (nestedFilters.unitIds.length > 0) {
//         data = data.filter((tenant) =>
//           nestedFilters.unitIds.includes(tenant.unit_id)
//         );
//       }
//       if (nestedFilters.tenantIds.length > 0) {
//         data = data.filter((tenant) =>
//           nestedFilters.tenantIds.includes(tenant.entity_id)
//         );
//       }
//       setFilteredData(data);
//     } else {
//       setFilteredData([]);
//     }
//   }, [tenantsWithPendingPayments, selectedFilters, searchQuery, nestedFilters]);

//   const handleFilterChange = (newFilters) => {
//     setNestedFilters(newFilters);
//   };

//   // 1. Calculate active filter count
//   const activeFilterCount = useMemo(() => {
//     let count = 0;
//     if (searchQuery.trim()) count++;
//     if (nestedFilters.buildingIds.length > 0) count++;
//     if (nestedFilters.unitIds.length > 0) count++;
//     return count;
//   }, [searchQuery, nestedFilters]);

//   // 2. Function to clear all filters
//   const handleClearAllFilters = () => {
//     setSearchQuery("");
//     // Resetting to an empty object will trigger the callback in the Filters component
//     // and clear its internal state, which then clears our nestedFilters state.
//     handleFilterChange({ buildingIds: [], unitIds: [], tenantIds: [] });
//   };

//   // --- Helper Functions (most are unchanged) ---
//   const toggleFilter = (filter) => {
//     setSelectedFilters((prev) =>
//       prev.includes(filter)
//         ? prev.filter((item) => item !== filter)
//         : [...prev, filter]
//     );
//   };
//   const getStatusProps = (due_date) => {
//     // This function remains the same
//     if (due_date === "Overdue") {
//       return {
//         label: "Overdue",
//         className: "text-red-500 border border-red-500",
//         icon: <CiCircleInfo size={15} color="red" />,
//       };
//     }
//     const dueInDays = parseInt(due_date, 10);
//     if (!isNaN(dueInDays)) {
//       if (dueInDays >= 0 && dueInDays <= 22) {
//         return {
//           label: `Due in ${dueInDays} days`,
//           className: "text-orange-500 border border-orange-500",
//           icon: <CiCircleInfo size={15} color="orange" />,
//         };
//       } else if (dueInDays >= 23 && dueInDays <= 31) {
//         return {
//           label: "Paid",
//           className: "text-blue-700 border border-blue-700",
//           icon: <CiWallet size={15} color="blue" />,
//         };
//       }
//     }
//     return { label: "Unknown", className: "bg-gray-500 text-white" };
//   };
//   const handleClearFilters = () => setSelectedFilters([]);
//   const navigateAddTenant = () => navigate("/AddNewTenant");

//   const filters = ["Active", "Paid", "Due", "Overdue", "Inactive"];

//   // --- Loading and Error States ---
//   if (isLoadingTenants) {
//     return (
//       <div className="flex justify-center items-center h-[calc(100vh-150px)]">
//         <Lottie
//           animationData={loaderAnimation}
//           loop={true}
//           style={{ width: 150, height: 150 }}
//         />
//       </div>
//     );
//   }

//   if (tenantError) {
//     return (
//       <div className="flex justify-center items-center h-48 text-red-600">
//         <p>Error: {tenantError}</p>
//         <button
//           onClick={() => fetchAllTenants(true)}
//           className="px-3 py-1 bg-blue-500 text-white rounded"
//         >
//           Retry
//         </button>
//       </div>
//     );
//   }

//   const handleNestedFilterChange = useCallback((newFiltersFromChild) => {
//     setFilters((prev) => ({
//       ...prev, // Keep existing filters like overdue, today, searchText
//       buildingIds: newFiltersFromChild.buildingIds,
//       unitIds: newFiltersFromChild.unitIds,
//       tenantIds: newFiltersFromChild.tenantIds,
//     }));
//   }, []);

//   // --- Main Render ---
//   return (
//     <div className="">
//       {/* Search and Filter Section (Unchanged) */}
//       {/* <div className="flex items-center justify-between mb-4">
//         <h2 className="text-2xl font-bold text-gray-800">My Tenants</h2>
//         <button
//           onClick={navigateAddTenant}
//           className="flex items-center bg-blue-700 text-white text-xs p-3 rounded-full"
//         >
//           <IoIosAdd size={15} />
//           Add New
//         </button>
//       </div> */}
//       <div className="filters-container bg-white rounded-lg shadow-sm border p-4 mb-4">
//         {/* Filter Header */}
//         <div className="flex items-center justify-between mb-4">
//           <div className="flex items-center gap-2">
//             <h3 className="text-lg font-medium">Filters</h3>
//             {activeFilterCount > 0 && (
//               <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
//                 {activeFilterCount} active
//               </span>
//             )}
//           </div>

//           {activeFilterCount > 0 && (
//             <button
//               onClick={handleClearAllFilters}
//               className="text-sm font-medium text-red-600 hover:text-red-800"
//             >
//               Clear All
//             </button>
//           )}
//         </div>

//         {/* Search Bar */}
//         <div className="mb-4">
//           <input
//             type="text"
//             placeholder="Search by name, mobile, unit, or building..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//           />
//         </div>

//         {/* Your reusable Filters component is placed here */}
//         {/* <Filters
//           onFilterChange={handleFilterChange}
//           availableFilters={["building", "unit"]}
//         /> */}
//         <Filters
//           onFilterChange={handleNestedFilterChange}
//           selectedFilters={{
//             buildingIds: filters.buildingIds,
//             unitIds: filters.unitIds,
//             tenantIds: filters.tenantIds,
//           }}
//         />
//       </div>
//       {/* <div className="tenant-filter-container mt-5">
//         <div className="flex flex-wrap gap-2">
//           <FilterBtn
//             selectedFiltersCount={selectedFilters.length}
//             onClick={handleClearFilters}
//           />
//           {filters.map((filter) => (
//             <ToggleBtn
//               key={filter}
//               label={filter}
//               isSelected={selectedFilters.includes(filter)}
//               onClick={() => toggleFilter(filter)}
//             />
//           ))}
//         </div>
//       </div> */}

//       {/* --- Tenant Table (Updated) --- */}
//       <div className="border rounded-lg shadow-sm overflow-hidden">
//         <div className="overflow-x-auto">
//           <table className="w-full min-w-[700px]">
//             <thead className="text-sm bg-gray-50">
//               <tr>
//                 <th className="px-4 py-3 text-left font-semibold">Name</th>
//                 <th className="px-4 py-3 text-left font-semibold">Contact</th>
//                 <th className="px-3 py-3 text-left font-semibold">Property</th>
//                 <th className="px-4 py-3 text-left font-semibold">Status</th>
//                 <th className="px-4 py-3 text-left font-semibold">Actions</th>
//                 {/* 🔥 ADDED COLUMN */}
//               </tr>
//             </thead>
//             <tbody>
//               {filteredData.length > 0 ? (
//                 filteredData.map((tenant) => {
//                   // 🔥 GET profile image URL
//                   const profileImageUrl = getTenantProfileImageURL(tenant);

//                   // 🔥 GENERATE dynamic WhatsApp message
//                   const pendingItemsDescription = tenant.pendingPayments
//                     .map(
//                       (item) =>
//                         `${item.nature === "rent" ? `${item.month} Rent` : "Security Deposit"}`
//                     )
//                     .join(", ");
//                   const whatsappMessage = `Hello ${tenant.first_name}. This is a friendly reminder for your pending payments: ${pendingItemsDescription}. Thank you.`;

//                   return (
//                     <tr
//                       className="text-xs border-b last:border-b-0 hover:bg-gray-50"
//                       key={tenant.entity_id}
//                     >
//                       <td className="px-4 py-2 flex items-center gap-3">
//                         {/* 🔥 RENDER Image or Initials */}
//                         {profileImageUrl ? (
//                           <img
//                             src={profileImageUrl}
//                             alt={`${tenant.first_name}'s profile`}
//                             className="h-9 w-9 rounded-full object-cover"
//                           />
//                         ) : (
//                           <div className="h-9 w-9 flex-shrink-0">
//                             <CircularInitial
//                               firstName={tenant.first_name}
//                               lastName={tenant.last_name}
//                             />
//                           </div>
//                         )}
//                         <p className="text-black font-medium">
//                           {tenant.first_name} {tenant.last_name}
//                         </p>
//                       </td>
//                       <td className="px-4 py-2">{tenant.mobile}</td>
//                       <td className="px-4 py-2">
//                         {tenant.unit_name}, {tenant.building_name}
//                       </td>
//                       <td className="px-4 py-2">
//                         <TenantStatusBtn {...getStatusProps(tenant.due_date)} />
//                       </td>
//                       <td className="px-4 py-2">
//                         {/* 🔥 RENDER pending info and Remind button */}
//                         {tenant.pendingPayments.length > 0 ? (
//                           <div className="flex items-center gap-2">
//                             <div className="flex flex-col">
//                               {tenant.pendingPayments.map((item) => (
//                                 <span
//                                   key={`${item.month}-${item.nature}`}
//                                   className="text-red-600 font-medium"
//                                 >
//                                   {item.nature === "rent"
//                                     ? `${item.month} Rent`
//                                     : "Security Deposit"}
//                                 </span>
//                               ))}
//                             </div>
//                             <WhatsAppComponent
//                               mobile={tenant.mobile}
//                               message={whatsappMessage}
//                             />
//                           </div>
//                         ) : (
//                           <div className="flex items-center gap-1.5 text-green-600">
//                             <FaCheckCircle />
//                             <span className="font-medium">No Dues</span>
//                           </div>
//                         )}
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td
//                     colSpan="5"
//                     className="px-4 py-10 text-gray-600 text-center"
//                   >
//                     No tenants match your current filters.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default TenantsList;

// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import { useAuth } from "../../Utility/AuthProvider";
// import { useNavigate } from "react-router-dom";
// import Lottie from "lottie-react";
// import { IoIosAdd } from "react-icons/io";
// import { CiCircleInfo, CiWallet } from "react-icons/ci";
// import { FaCheckCircle } from "react-icons/fa";

// // --- Context Imports ---
// import { useTenantContext } from "../Tenants/TenantContext";
// import { useReportsData } from "../../Contexts/ReportsContext";

// // --- Component & Utility Imports ---
// import Filters from "../Common/Filter"; // 🔥 The child component
// import TenantStatusBtn from "../../components/Buttons/TenantStatusBtn";
// import CircularInitial from "../UpcomingRent/CircularInitial";
// import WhatsAppComponent from "../Reports/components/WhatsappComponent";
// import { getTenantProfileImageURL } from "../../Utility/tenantFileUtils";
// import loaderAnimation from "../../assets/animations/loader.json";

// function TenantsList() {
//   const { jwt } = useAuth();
//   const navigate = useNavigate();

//   // --- Consume Contexts ---
//   const { tenantData, isLoadingTenants, tenantError, fetchAllTenants } =
//     useTenantContext();
//   const { rentData } = useReportsData();

//   // --- Local State ---
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");

//   // 🔥 1. CONSOLIDATED STATE: This is the single source of truth for our filters.
//   // We've renamed `nestedFilters` to `activeFilters` for clarity.
//   const [activeFilters, setActiveFilters] = useState({
//     buildingIds: [],
//     unitIds: [],
//     tenantIds: [],
//   });

//   const tenantsWithPendingPayments = useMemo(() => {
//     // ... (This logic is correct and does not need to change)
//     if (!tenantData || !rentData?.all) return [];
//     const allPendingItems = rentData.all.flatMap((section) =>
//       section.data.filter((item) => item.due_in)
//     );
//     const pendingPaymentsMap = new Map();
//     allPendingItems.forEach((item) => {
//       if (!pendingPaymentsMap.has(item.tenant_id)) {
//         pendingPaymentsMap.set(item.tenant_id, []);
//       }
//       pendingPaymentsMap.get(item.tenant_id).push(item);
//     });
//     return tenantData.map((tenant) => ({
//       ...tenant,
//       pendingPayments: pendingPaymentsMap.get(tenant.entity_id) || [],
//     }));
//   }, [tenantData, rentData]);

//   // --- Filtering Logic ---
//   useEffect(() => {
//     if (tenantsWithPendingPayments) {
//       let data = [...tenantsWithPendingPayments];

//       // Filter by search query
//       if (searchQuery) {
//         data = data.filter(
//           (tenant) =>
//             `${tenant.first_name} ${tenant.last_name}`
//               .toLowerCase()
//               .includes(searchQuery.toLowerCase()) ||
//             tenant.mobile?.includes(searchQuery) ||
//             tenant.unit_name?.toLowerCase().includes(searchQuery.toLowerCase())
//         );
//       }

//       // 🔥 2. UPDATED FILTERING: Use the consolidated `activeFilters` state.
//       if (activeFilters.buildingIds.length > 0) {
//         data = data.filter((tenant) =>
//           activeFilters.buildingIds.includes(tenant.building_id)
//         );
//       }
//       if (activeFilters.unitIds.length > 0) {
//         data = data.filter((tenant) =>
//           activeFilters.unitIds.includes(tenant.unit_id)
//         );
//       }
//       if (activeFilters.tenantIds.length > 0) {
//         data = data.filter((tenant) =>
//           activeFilters.tenantIds.includes(tenant.entity_id)
//         );
//       }

//       setFilteredData(data);
//     } else {
//       setFilteredData([]);
//     }
//   }, [tenantsWithPendingPayments, searchQuery, activeFilters]); // 🔥 Dependency array is now correct.

//   // 🔥 3. CORRECT HANDLER: This single function receives the complete new filter object from the child.
//   const handleFilterChange = useCallback((newFiltersFromChild) => {
//     setActiveFilters(newFiltersFromChild);
//   }, []);

//   const activeFilterCount = useMemo(() => {
//     let count = 0;
//     if (searchQuery.trim()) count++;
//     count += Object.values(activeFilters).filter(
//       (arr) => arr.length > 0
//     ).length;
//     return count;
//   }, [searchQuery, activeFilters]);

//   const handleClearAllFilters = () => {
//     setSearchQuery("");
//     // Directly reset the filter state object
//     setActiveFilters({ buildingIds: [], unitIds: [], tenantIds: [] });
//   };

//   // Helper functions that are no longer needed have been removed (toggleFilter, handleClearFilters)
//   const getStatusProps = (due_date) => {
//     // ... (This function is correct and does not need to change)
//     if (due_date === "Overdue")
//       return {
//         label: "Overdue",
//         className: "text-red-500 border border-red-500",
//         icon: <CiCircleInfo size={15} color="red" />,
//       };
//     const dueInDays = parseInt(due_date, 10);
//     if (!isNaN(dueInDays)) {
//       if (dueInDays >= 0 && dueInDays <= 22)
//         return {
//           label: `Due in ${dueInDays} days`,
//           className: "text-orange-500 border border-orange-500",
//           icon: <CiCircleInfo size={15} color="orange" />,
//         };
//       if (dueInDays >= 23 && dueInDays <= 31)
//         return {
//           label: "Paid",
//           className: "text-blue-700 border border-blue-700",
//           icon: <CiWallet size={15} color="blue" />,
//         };
//     }
//     return { label: "Unknown", className: "bg-gray-500 text-white" };
//   };

//   if (isLoadingTenants) {
//     /* ... Loading JSX ... */
//   }
//   if (tenantError) {
//     /* ... Error JSX ... */
//   }

//   // --- Main Render ---
//   return (
//     <div className="">
//       <div className="filters-container bg-white rounded-lg shadow-sm border p-4 mb-4">
//         <div className="flex items-center justify-between mb-4">
//           <div className="flex items-center gap-2">
//             <h3 className="text-lg font-medium">Filters</h3>
//             {activeFilterCount > 0 && (
//               <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
//                 {activeFilterCount} active
//               </span>
//             )}
//           </div>
//           {activeFilterCount > 0 && (
//             <button
//               onClick={handleClearAllFilters}
//               className="text-sm font-medium text-red-600 hover:text-red-800"
//             >
//               Clear All
//             </button>
//           )}
//         </div>

//         <div className="mb-4">
//           <input
//             type="text"
//             placeholder="Search by name, mobile, unit, or building..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//           />
//         </div>

//         {/* 🔥 4. CORRECT PROPS: Pass the state and the handler to the Filters component. */}
//         <Filters
//           onFilterChange={handleFilterChange}
//           selectedFilters={activeFilters}
//           availableFilters={["building", "unit", "tenant"]} // Specify which filters to show
//         />
//       </div>

//       {/* The old filter buttons have been removed as they are now inside the Filters component */}

//       <div className="border rounded-lg shadow-sm overflow-hidden">
//         {/* ... The rest of your table JSX remains the same ... */}
//         <div className="overflow-x-auto">
//           <table className="w-full min-w-[700px]">
//             {/* Table Head */}
//             <thead className="text-sm bg-gray-50">
//               <tr>
//                 <th className="px-4 py-3 text-left font-semibold">Name</th>
//                 {/* <th className="px-3 py-3 text-left font-semibold">Property</th> */}
//                 <th className="px-3 py-3 text-left font-semibold">Unit</th>

//                 <th className="px-3 py-3 text-left font-semibold">Building</th>
//                 <th className="px-4 py-3 text-left font-semibold">Contact</th>
//                 {/* <th className="px-4 py-3 text-left font-semibold">Status</th> */}
//                 <th className="px-4 py-3 text-left font-semibold">Actions</th>
//               </tr>
//             </thead>
//             {/* Table Body */}
//             <tbody>
//               {filteredData.length > 0 ? (
//                 filteredData.map((tenant) => {
//                   const profileImageUrl = getTenantProfileImageURL(tenant);
//                   const pendingItemsDescription = tenant.pendingPayments
//                     .map((item) =>
//                       item.nature === "rent"
//                         ? `${item.month} Rent`
//                         : "Security Deposit"
//                     )
//                     .join(", ");
//                   const whatsappMessage = `Hello ${tenant.first_name}. This is a friendly reminder for your pending payments: ${pendingItemsDescription}. Thank you.`;

//                   return (
//                     <tr
//                       className="text-xs border-b last:border-b-0 hover:bg-gray-50"
//                       key={tenant.entity_id}
//                     >
//                       <td className="px-4 py-2 flex items-center gap-3">
//                         {profileImageUrl ? (
//                           <img
//                             src={profileImageUrl}
//                             alt={`${tenant.first_name}'s profile`}
//                             className="h-9 w-9 rounded-full object-cover"
//                           />
//                         ) : (
//                           <div className="h-9 w-9 flex-shrink-0">
//                             <CircularInitial
//                               firstName={tenant.first_name}
//                               lastName={tenant.last_name}
//                             />
//                           </div>
//                         )}
//                         <p className="text-black font-medium">
//                           {tenant.first_name} {tenant.last_name}
//                         </p>
//                       </td>
//                       <td className="px-4 py-2">{tenant.unit_name}</td>
//                       <td className="px-4 py-2">{tenant.building_name}</td>
//                       <td className="px-4 py-2">{tenant.mobile}</td>

//                       {/* <td className="px-4 py-2">
//                         <TenantStatusBtn {...getStatusProps(tenant.due_date)} />
//                       </td> */}
//                       {/* <td className="px-4 py-2">
//                         {tenant.pendingPayments.length > 0 ? (
//                           <div className="flex items-center gap-2">
//                             <div className="flex flex-col">
//                               {tenant.pendingPayments.map((item) => (
//                                 <span
//                                   key={`${item.month}-${item.nature}`}
//                                   className="text-red-600 font-medium"
//                                 >
//                                   {item.nature === "rent"
//                                     ? `${item.month} Rent`
//                                     : "Security Deposit"}
//                                 </span>
//                               ))}
//                             </div>
//                             <WhatsAppComponent
//                               mobile={tenant.mobile}
//                               message={whatsappMessage}
//                             />
//                           </div>
//                         ) : (
//                           <div className="flex items-center gap-1.5 text-green-600">
//                             <FaCheckCircle />
//                             <span className="font-medium">No Dues</span>
//                           </div>
//                         )}
//                       </td> */}
//                       <td>
//                         <WhatsAppComponent
//                           mobile={tenant.mobile}
//                           message={whatsappMessage}
//                         />
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td
//                     colSpan="5"
//                     className="px-4 py-10 text-gray-600 text-center"
//                   >
//                     No tenants match your current filters.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default TenantsList;

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useAuth } from "../../Utility/AuthProvider";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import { IoIosAdd, IoIosCall } from "react-icons/io";
import { CiCircleInfo, CiWallet } from "react-icons/ci";
import { FaCheckCircle, FaWhatsapp } from "react-icons/fa";

// --- Context Imports ---
import { useTenantContext } from "../Tenants/TenantContext";
import { useReportsData } from "../../Contexts/ReportsContext";

// --- Component & Utility Imports ---
import Filters from "../Common/Filter";
import TenantStatusBtn from "../../components/Buttons/TenantStatusBtn";
import CircularInitial from "../UpcomingRent/CircularInitial";
// import TenantDetailsModal from "./TenantDetailsModal"; // 🔥 NEW: Import TenantDetailsModal
import TenantDetailsModal from "../Modals/TenantDetailsModal";
import { getTenantProfileImageURL } from "../../Utility/tenantFileUtils";
import loaderAnimation from "../../assets/animations/loader.json";

function TenantsList() {
  const { jwt } = useAuth();
  const navigate = useNavigate();

  // --- Consume Contexts ---
  const { tenantData, isLoadingTenants, tenantError, fetchAllTenants } =
    useTenantContext();
  const { rentData } = useReportsData();

  // --- Local State ---
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // 🔥 NEW: Modal state for TenantDetailsModal
  const [selectedTenantForModal, setSelectedTenantForModal] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 🔥 CONSOLIDATED STATE: Single source of truth for filters
  const [activeFilters, setActiveFilters] = useState({
    buildingIds: [],
    unitIds: [],
    tenantIds: [],
  });

  const tenantsWithPendingPayments = useMemo(() => {
    if (!tenantData || !rentData?.all) return [];
    const allPendingItems = rentData.all.flatMap((section) =>
      section.data.filter((item) => item.due_in)
    );
    const pendingPaymentsMap = new Map();
    allPendingItems.forEach((item) => {
      if (!pendingPaymentsMap.has(item.tenant_id)) {
        pendingPaymentsMap.set(item.tenant_id, []);
      }
      pendingPaymentsMap.get(item.tenant_id).push(item);
    });
    return tenantData.map((tenant) => ({
      ...tenant,
      pendingPayments: pendingPaymentsMap.get(tenant.entity_id) || [],
    }));
  }, [tenantData, rentData]);

  // --- Filtering Logic ---
  useEffect(() => {
    if (tenantsWithPendingPayments) {
      let data = [...tenantsWithPendingPayments];

      // Filter by search query
      if (searchQuery) {
        data = data.filter(
          (tenant) =>
            `${tenant.first_name} ${tenant.last_name}`
              .toLowerCase()
              .includes(searchQuery.toLowerCase()) ||
            tenant.mobile?.includes(searchQuery) ||
            tenant.unit_name
              ?.toLowerCase()
              .includes(searchQuery.toLowerCase()) ||
            tenant.building_name
              ?.toLowerCase()
              .includes(searchQuery.toLowerCase())
        );
      }

      // Apply filters
      if (activeFilters.buildingIds.length > 0) {
        data = data.filter((tenant) =>
          activeFilters.buildingIds.includes(tenant.building_id)
        );
      }
      if (activeFilters.unitIds.length > 0) {
        data = data.filter((tenant) =>
          activeFilters.unitIds.includes(tenant.unit_id)
        );
      }
      if (activeFilters.tenantIds.length > 0) {
        data = data.filter((tenant) =>
          activeFilters.tenantIds.includes(tenant.entity_id)
        );
      }

      setFilteredData(data);
    } else {
      setFilteredData([]);
    }
  }, [tenantsWithPendingPayments, searchQuery, activeFilters]);

  // 🔥 FILTER HANDLERS
  const handleFilterChange = useCallback((newFiltersFromChild) => {
    setActiveFilters(newFiltersFromChild);
  }, []);

  const activeFilterCount = useMemo(() => {
    let count = 0;
    if (searchQuery.trim()) count++;
    count += Object.values(activeFilters).filter(
      (arr) => arr.length > 0
    ).length;
    return count;
  }, [searchQuery, activeFilters]);

  const handleClearAllFilters = () => {
    setSearchQuery("");
    setActiveFilters({ buildingIds: [], unitIds: [], tenantIds: [] });
  };

  // 🔥 NEW: Modal handlers
  const handleTenantClick = useCallback((tenant) => {
    console.log(
      "🔄 Opening tenant details modal for:",
      tenant.first_name,
      tenant.last_name
    );
    setSelectedTenantForModal(tenant);
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    console.log("🔙 Closing tenant details modal");
    setSelectedTenantForModal(null);
    setIsModalOpen(false);
  }, []);

  // 🔥 NEW: Action handlers for Call and WhatsApp
  const handleCallClick = useCallback((tenant, event) => {
    event.stopPropagation(); // Prevent row click
    console.log("📞 Making call to:", tenant.mobile);
    if (tenant.mobile) {
      window.open(`tel:${tenant.mobile}`, "_self");
    }
  }, []);

  const handleWhatsAppClick = useCallback((tenant, event) => {
    event.stopPropagation(); // Prevent row click
    console.log("💬 Opening WhatsApp for:", tenant.mobile);

    if (!tenant.mobile) return;

    const pendingItemsDescription = tenant.pendingPayments
      .map((item) =>
        item.nature === "rent" ? `${item.month} Rent` : "Security Deposit"
      )
      .join(", ");

    const message =
      tenant.pendingPayments.length > 0
        ? `Hello ${tenant.first_name}. This is a friendly reminder for your pending payments: ${pendingItemsDescription}. Thank you.`
        : `Hello ${tenant.first_name}, hope you're doing well!`;

    const encodedMessage = encodeURIComponent(message);
    window.open(
      `https://wa.me/${tenant.mobile}?text=${encodedMessage}`,
      "_blank"
    );
  }, []);

  // Helper function (unchanged)
  const getStatusProps = (due_date) => {
    if (due_date === "Overdue")
      return {
        label: "Overdue",
        className: "text-red-500 border border-red-500",
        icon: <CiCircleInfo size={15} color="red" />,
      };
    const dueInDays = parseInt(due_date, 10);
    if (!isNaN(dueInDays)) {
      if (dueInDays >= 0 && dueInDays <= 22)
        return {
          label: `Due in ${dueInDays} days`,
          className: "text-orange-500 border border-orange-500",
          icon: <CiCircleInfo size={15} color="orange" />,
        };
      if (dueInDays >= 23 && dueInDays <= 31)
        return {
          label: "Paid",
          className: "text-blue-700 border border-blue-700",
          icon: <CiWallet size={15} color="blue" />,
        };
    }
    return { label: "Unknown", className: "bg-gray-500 text-white" };
  };

  if (isLoadingTenants) {
    return (
      <div className="flex justify-center items-center py-20">
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          style={{ width: 100, height: 100 }}
        />
      </div>
    );
  }

  if (tenantError) {
    return (
      <div className="text-center py-10">
        <p className="text-red-500">Error loading tenants: {tenantError}</p>
        <button
          onClick={fetchAllTenants}
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Retry
        </button>
      </div>
    );
  }

  // --- Main Render ---
  return (
    <div className="">
      {/* Filters Container */}
      <div className="filters-container bg-white rounded-lg shadow-sm border p-4 mb-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <h3 className="text-lg font-medium">Filters</h3>
            {activeFilterCount > 0 && (
              <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                {activeFilterCount} active
              </span>
            )}
          </div>
          {activeFilterCount > 0 && (
            <button
              onClick={handleClearAllFilters}
              className="text-sm font-medium text-red-600 hover:text-red-800"
            >
              Clear All
            </button>
          )}
        </div>

        <div className="mb-4">
          <input
            type="text"
            placeholder="Search by name, mobile, unit, or building..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <Filters
          onFilterChange={handleFilterChange}
          selectedFilters={activeFilters}
          availableFilters={["building", "unit", "tenant"]}
        />
      </div>

      {/* Table Container */}
      <div className="border rounded-lg shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[700px]">
            {/* Table Head */}
            <thead className="text-sm bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left font-semibold">Name</th>
                <th className="px-3 py-3 text-left font-semibold">Unit</th>
                <th className="px-3 py-3 text-left font-semibold">Building</th>
                <th className="px-4 py-3 text-left font-semibold">Contact</th>
                <th className="px-4 py-3 text-center font-semibold">Actions</th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((tenant) => {
                  const profileImageUrl = getTenantProfileImageURL(tenant);

                  return (
                    <tr
                      className="text-xs border-b last:border-b-0 hover:bg-blue-50 hover:shadow-sm transition-all duration-200 cursor-pointer"
                      key={tenant.entity_id}
                      onClick={() => handleTenantClick(tenant)}
                      title="Click to view tenant details"
                    >
                      <td className="px-4 py-3 flex items-center gap-3">
                        {profileImageUrl ? (
                          <img
                            src={profileImageUrl}
                            alt={`${tenant.first_name}'s profile`}
                            className="h-10 w-10 rounded-full object-cover border-2 border-gray-200"
                          />
                        ) : (
                          <div className="h-10 w-10 flex-shrink-0">
                            <CircularInitial
                              firstName={tenant.first_name}
                              lastName={tenant.last_name}
                            />
                          </div>
                        )}
                        <div>
                          <p className="text-black font-medium text-sm">
                            {tenant.first_name} {tenant.last_name}
                          </p>
                          {/* {tenant.pendingPayments.length > 0 && (
                            <div className="flex flex-wrap gap-1 mt-1">
                              {tenant.pendingPayments
                                .slice(0, 2)
                                .map((item, index) => (
                                  <span
                                    key={`${item.month}-${item.nature}-${index}`}
                                    className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded-full"
                                  >
                                    {item.nature === "rent"
                                      ? `${item.month} Rent`
                                      : "Security Deposit"}
                                  </span>
                                ))}
                              {tenant.pendingPayments.length > 2 && (
                                <span className="text-xs bg-gray-100 text-gray-700 px-2 py-0.5 rounded-full">
                                  +{tenant.pendingPayments.length - 2} more
                                </span>
                              )}
                            </div>
                          )}
                          {tenant.pendingPayments.length === 0 && (
                            <div className="flex items-center gap-1 mt-1">
                              <FaCheckCircle className="text-green-600 text-xs" />
                              <span className="text-xs text-green-600 font-medium">
                                No Dues
                              </span>
                            </div>
                          )} */}
                        </div>
                      </td>

                      <td className="px-4 py-3">
                        <span className="text-sm font-medium">
                          {tenant.unit_name}
                        </span>
                      </td>

                      <td className="px-4 py-3">
                        <span className="text-sm">{tenant.building_name}</span>
                      </td>

                      <td className="px-4 py-3">
                        <span className="text-sm font-mono">
                          {tenant.mobile}
                        </span>
                      </td>

                      <td className="px-4 py-3">
                        <div className="flex items-center justify-center gap-3">
                          {/* Call Button */}
                          <button
                            onClick={(e) => handleCallClick(tenant, e)}
                            className="group relative p-2.5 bg-blue-100 text-blue-600 rounded-full hover:bg-blue-200 hover:scale-105 transition-all duration-200 shadow-sm hover:shadow-md"
                            title="Make a call"
                          >
                            <IoIosCall size={18} />
                            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-200 pointer-events-none z-10">
                              Call {tenant.first_name}
                            </div>
                          </button>

                          {/* WhatsApp Button */}
                          <button
                            onClick={(e) => handleWhatsAppClick(tenant, e)}
                            className="group relative p-2.5 bg-green-100 text-green-600 rounded-full hover:bg-green-200 hover:scale-105 transition-all duration-200 shadow-sm hover:shadow-md"
                            title="Send WhatsApp message"
                          >
                            <FaWhatsapp size={18} />
                            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-200 pointer-events-none z-10">
                              WhatsApp {tenant.first_name}
                            </div>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    className="px-4 py-10 text-gray-600 text-center"
                  >
                    <div className="flex flex-col items-center justify-center">
                      <div className="text-gray-400 mb-2">
                        <svg
                          className="w-12 h-12"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                          />
                        </svg>
                      </div>
                      <p className="font-medium">
                        No tenants match your current filters.
                      </p>
                      <p className="text-sm text-gray-500 mt-1">
                        Try adjusting your search or filters
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* 🔥 NEW: Tenant Details Modal */}
      {selectedTenantForModal && (
        <TenantDetailsModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          selectedTenant={selectedTenantForModal}
          unitDetails={{
            tenant: selectedTenantForModal,
            unit: {
              unit_name: selectedTenantForModal?.unit_name,
              building_name: selectedTenantForModal?.building_name,
              localRent: selectedTenantForModal?.rent,
            },
            agreement: {
              rent: [{ rent: selectedTenantForModal?.rent }],
              due_date: selectedTenantForModal?.due_date,
              security_deposit: selectedTenantForModal?.security_deposit,
              staying_from: selectedTenantForModal?.staying_from,
              tenure: selectedTenantForModal?.tenure,
            },
          }}
          allAgreementTenants={filteredData.filter(
            (t) => t.agreement_id === selectedTenantForModal?.agreement_id
          )}
          jwt={jwt}
        />
      )}
    </div>
  );
}

export default TenantsList;
